import { parseMoneyInput } from "../utils/priceFormat";
import { apiRequest } from "./apiClient";
import { bagliHatirlaticilariSil } from "./linkedReminderService";
import { emitRestDataChanged } from "./restEventBus";
import { detectReceiptCategory, normalizeReceiptCategory } from "./receiptCategoryService";
import { trackEngagementDataAdded } from "./engagementService";

const enc = (v) => encodeURIComponent(String(v || ""));

export const harcamalariGetirService = async (familyId, month = null) => {
  if (!familyId) return [];
  const qs = month ? `?month=${enc(month)}` : "";
  const data = await apiRequest(`/shared-expenses/${enc(familyId)}${qs}`);
  return Array.isArray(data?.items) ? data.items : [];
};

export const harcamaEkleService = async ({
  familyId,
  harcamaBaslik,
  harcamaTutar,
  harcamaKategori,
  harcamaTarih,
  tamAd,
  user,
  notificationMode = "single",
  bulkBatchId = null,
  bulkTotal = null,
}) => {
  const payload = {
    baslik: harcamaBaslik,
    tutar: parseMoneyInput(harcamaTutar),
    kategori: harcamaKategori,
    tarih: harcamaTarih,
    ekleyen: tamAd,
    tamAd,
    ekleyenUid: user?.uid,
    createdAt: new Date().toISOString(),
  };

  const data = await apiRequest(`/shared-expenses/${enc(familyId)}`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  const item = data?.item || payload;
  const id = item?.id || item?.firebaseId;
  const extra = notificationMode === "bulkOcr"
    ? { silentNotification: true, bulkBatchId, bulkTotal, source: "receipt_ocr", financeItem: data?.financeItem }
    : { financeItem: data?.financeItem };
  trackEngagementDataAdded({ familyId, moduleKey: "expenses", itemId: id, metadata: { source: notificationMode } });
  emitRestDataChanged({ familyId, resource: "sharedExpenses", action: "added", item, extra });
  if (data?.financeItem) {
    emitRestDataChanged({
      familyId,
      resource: "finance",
      action: "added",
      item: data.financeItem,
      extra: notificationMode === "bulkOcr"
        ? { silentNotification: true, bulkBatchId, bulkTotal, source: "receipt_ocr" }
        : undefined,
    });
  }
  return id;
};

export const harcamalariTopluEkleService = async ({
  familyId,
  kalemler = [],
  harcamaKategori,
  harcamaTarih,
  tamAd,
  user,
}) => {
  const items = (kalemler || [])
    .map((x) => {
      const ad = String(x?.ad || x?.baslik || "").trim();
      const rawKategori = x?.kategori || x?.category || x?.expenseCategory || x?.harcamaKategori || x?.finansKategori;
      return {
        ad,
        fiyat: Number(x?.fiyat ?? x?.tutar ?? 0),
        kategori: rawKategori ? normalizeReceiptCategory(rawKategori) : detectReceiptCategory(ad),
      };
    })
    .filter((x) => x.ad && Number.isFinite(x.fiyat) && x.fiyat > 0)
    .slice(0, 80);

  if (!familyId || !user || items.length === 0) return { count: 0, ids: [] };

  const bulkBatchId = `receipt_ocr_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  const ids = [];

  for (const item of items) {
    try {
      const id = await harcamaEkleService({
        familyId,
        harcamaBaslik: item.ad,
        harcamaTutar: item.fiyat,
        harcamaKategori: item.kategori || normalizeReceiptCategory(harcamaKategori || "Market"),
        harcamaTarih,
        tamAd,
        user,
        notificationMode: "bulkOcr",
        bulkBatchId,
        bulkTotal: items.length,
      });
      if (id) ids.push(id);
    } catch {}
  }

  if (ids.length > 0) {
    emitRestDataChanged({
      familyId,
      resource: "sharedExpenses",
      action: "bulkAdded",
      extra: {
        source: "receipt_ocr",
        bulkBatchId,
        count: ids.length,
        total: items.length,
        itemIds: ids,
        ekleyen: tamAd,
        ekleyenUid: user?.uid,
      },
    });
  }

  return { count: ids.length, ids };
};

export const harcamaSilService = async ({ familyId, harcama }) => {
  await bagliHatirlaticilariSil({
    familyId,
    kaynak: "sharedExpense",
    kaynakId: harcama?.id,
    reminderId: harcama?.reminderId,
    reminderIds: harcama?.reminderIds,
  });

  await apiRequest(`/shared-expenses/${enc(familyId)}/${enc(harcama.id)}`, { method: "DELETE" });
  emitRestDataChanged({ familyId, resource: "sharedExpenses", action: "deleted", itemId: harcama.id });
  if (harcama.financeId) emitRestDataChanged({ familyId, resource: "finance", action: "deleted", itemId: harcama.financeId });
};
